import { CompanySelector } from '@/components/global/selectors/CompanySelector';

interface CompanyAsyncSelectProps {
    value?: string;
    onValueChange: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
    className?: string;
    /**
     * Resolves the current value's label without a search. Needed when the field is
     * prefilled — and doubly so when it is disabled, since it can never be opened to
     * load the list itself.
     */
    seedCompanies?: Array<{ id?: string; uuid?: string; name?: string }>;
}

/** The project forms' company field. Empty string rather than null, which is what the form state holds. */
export function CompanyAsyncSelect({ value, onValueChange, placeholder, disabled = false, className, seedCompanies }: CompanyAsyncSelectProps) {
    return (
        <CompanySelector
            value={value}
            onValueChange={(next) => onValueChange(next ?? '')}
            labels={placeholder ? { placeholder } : undefined}
            disabled={disabled}
            seedCompanies={seedCompanies}
            className={className}
        />
    );
}
